import React, { useState, useEffect } from 'react';
import { getQRCode } from '../../services/restaurantService';
import { toast } from 'react-toastify';
import { Link, useParams } from 'react-router-dom';

function QRCodePage() {
  const { restaurantId } = useParams();

  const [qrCodeUrl, setQRCodeUrl] = useState('');

  useEffect(() => {
    const fetchQRCode = async () => {
      try {
        const response = await getQRCode(restaurantId);
        setQRCodeUrl(response.qrCode);
      } catch (error) {
        toast.error('Failed to load QR code.');
      }
    };
    fetchQRCode();
  }, [restaurantId]);

  const handleDownloadQRCode = () => {
    const link = document.createElement('a');
    link.href = qrCodeUrl;
    link.download = 'restaurant_qrcode.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    // <div>
    //   <h2 className='text-2xl font-bold mb-6'>Download QR Code</h2>
    //   {qrCodeUrl ? (
    //     <div>
    //       <img src={qrCodeUrl} alt='Restaurant QR Code' className='mb-4' />
    //       <button
    //         className='bg-blue-500 text-white py-2 px-4 rounded-lg'
    //         onClick={handleDownloadQRCode}
    //       >
    //         Download QR Code
    //       </button>
    //     </div>
    //   ) : (
    //     <p>Loading QR code...</p>
    //   )}
    // </div>
    <div className='space-y-4'>
      <h2 className='text-2xl font-bold'>QR Code</h2>
      <h4 className='text-md font-bold mb-4 text-gray-700'>
        Download your restaurant's QR code. Print this coupon and let your
        customers scan this code to subscribe for news, promotions, and coupons
      </h4>
      {qrCodeUrl ? (
        <div className='space-y-4'>
          <img src={qrCodeUrl} alt='Restaurant QR Code' />
          <div className='flex flex-col gap-2 w-[200px]'>
            <Link to={`/subscribe/${restaurantId}`}>
              <h4 className='bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700 text-center'>
                Link to Subscribe
              </h4>
            </Link>
            <button
              onClick={handleDownloadQRCode}
              className='bg-indigo-600 text-white px-2 py-2 rounded hover:bg-indigo-700 '
            >
              Download QR Code
            </button>
          </div>
        </div>
      ) : (
        <p>No QR code available.</p>
      )}
    </div>
  );
}

export default QRCodePage;
